module.exports = __webpack_public_path__ + "img/编组3.cd0ec81a.png";